import { queryOptions, skipToken } from '@tanstack/react-query';

import { getInstagramAccount } from '../api';

export const instagramQueries = {
  all: (pharmacyId: string | undefined) => ['instagram', pharmacyId] as const,
  account: (pharmacyId: string | undefined) =>
    queryOptions({
      queryKey: [...instagramQueries.all(pharmacyId), 'account'],
      queryFn: pharmacyId ? () => getInstagramAccount(pharmacyId) : skipToken,
    }),
};
